
// You can write more code here

/* START OF COMPILED CODE */

import EditorPlatformMarkerImage from "../../../EditorPlatformMarkerImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformMarkerJungleLogKnot extends EditorPlatformMarkerImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 265.5, y ?? 21.5, texture || 'game-all', frame ?? "log-knot.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
